import VDMDashboardSecurity from "components/app/vdmdashboard/security/VDMDashboardSecurity";
import React from "react";

type ScreenVDMDashboardSecurityType = React.PropsWithChildren<{
	match: {
		params: {
			vesselId: string;
		};
	};
}>;
const ScreenVDMDashboardSecurity: React.FC<ScreenVDMDashboardSecurityType> = (
	props: ScreenVDMDashboardSecurityType
) => {
	return <VDMDashboardSecurity vesselId={props.match.params.vesselId} />;
};

export default ScreenVDMDashboardSecurity;
